<template>
    <Sidebar />
    <Content class="account-billing-content">
        <div class="inner">
            Coming soon
        </div>
    </Content>
</template>

<script>
import Sidebar from '@/components/Sidebar.vue';
import Content from '@/components/ui/Content.vue';

export default {
    name: 'AccountBilling',

    data() {
        return {
        }
    },

    components: {
        Sidebar,
        Content,
    },

    methods: {
        
    },

    mounted() {

    },
}
</script>

<style lang="scss">
    .account-billing-content {
        .inner {
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            font: var(--font-fg-24);
        }
    }
</style>